import React, { ReactNode } from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { Text } from '../Text';
interface Props {
  /** The boolean value of the component that represents on/off, checked/unchecked */
  checked: boolean;
  /** A label for the toggle */
  children?: ReactNode;
  /** Pass through classname to allow styles overrides */
  className?: string;
  /** The id for label and input element */
  id: string;
  /** Identify the element for selection in integration tests, FullStory, etc. */
  dataId?: string;
  /** The toggle click handler */
  onChange: (event: React.SyntheticEvent<Element, Event>) => void;
  /** Use larger touch area */
  hasTouchArea?: boolean;
  /** Optional aria-labelledby for screen-readers, used when labelled by another element */
  ariaLabelledBy?: string;
}
const Switch = /*#__PURE__*/styled('div')({
  name: "Switch",
  class: "skr9t2i",
  propsAsIs: false
});
const Slider = /*#__PURE__*/styled('div')({
  name: "Slider",
  class: "saitk2t",
  propsAsIs: false
});
const Input = /*#__PURE__*/styled('input')({
  name: "Input",
  class: "i16qyck8",
  propsAsIs: false
});
const Label = /*#__PURE__*/styled('label')({
  name: "Label",
  class: "l1cau0nx",
  propsAsIs: false
});
export const Toggle = ({
  onChange,
  checked,
  children,
  id,
  dataId,
  hasTouchArea,
  className,
  ariaLabelledBy
}: Props) => {
  return <Label htmlFor={id} data-id={dataId} className={cx(hasTouchArea && 'hasTouchArea', checked && 'isChecked', className)}>
      <Switch>
        <Input id={id} type="checkbox" checked={checked} onChange={onChange} aria-labelledby={ariaLabelledBy} />
        <Slider />
      </Switch>
      {children && <Text variant="bodyS">{children}</Text>}
    </Label>;
};

require("./Toggle.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./Toggle.tsx");